<template>
    <div class="literacy">
        <div class="literacy_conternt">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import LiteracyEvaluationModule from "./component/LiteracyEvaluationModule.vue";
export default {
    name: "teacherMatingDetail",
    data() {
        return {
            tablist: [
                { name: "素养评价", id: 1 },
                { name: "素养评定细则", id: 2 },
            ],
            activeTabItem: 1,
        };
    },

    components: {
        LiteracyEvaluationModule,
    },
    methods: {
        clickTab(id) {
            this.activeTabItem = id;
        },
    },
};
</script>

<style scoped lang="scss">
.literacy {
    width: 100%;
    height: 100%;
    padding: 20px;
    box-sizing: border-box;

    .literacy_conternt {
        width: 100%;
        height: 100%;
        background: #ffffff;
        border-radius: 4px 4px 4px 4px;
    }
}
/* 设置滚动条整体 */
::-webkit-scrollbar {
    width: 3px; /* 滚动条宽度 */
    height: 6px; /* 水平滚动条高度 */
}

/* 设置滚动条轨道 */
::-webkit-scrollbar-track {
    background: #f1f1f1; /* 轨道背景色 */
}

/* 设置滚动条滑块 */
::-webkit-scrollbar-thumb {
    background: #d3d2d2; /* 滑块背景色 */
    border-radius: 6px; /* 滑块圆角 */
}

/* 设置滚动条滑块悬停时的样式 */
::-webkit-scrollbar-thumb:hover {
    background: #555; /* 滑块悬停背景色 */
}
</style>